import React, { useMemo, memo } from 'react'
import { useSelector } from 'react-redux'

import { useCurrentTokenType } from '../../../../utils/tokenTypes'

export const withFilteredPairs = Component =>
  memo(props => {
    const tokenType = useCurrentTokenType()
    const allPairs = useSelector(state => state.tradePairs.pairs)
    const filteredPairs = useMemo(() => allPairs.filter(it => it.tokenType === tokenType), [
      allPairs,
      tokenType,
    ])

    return <Component {...props} pairs={filteredPairs} />
  })
